export default [
    {
        path: 'explain-rule',
        name: 'explainRule',
        component: require('@/components/explainRule'),
    },
    {
        path: 'explain-detailed',
        name: 'explainDetailed',
        component: require('@/components/explainDetailed'),
    },
    {
        path: 'explain-why',
        name: 'explainWhy',
        component: require('@/components/explainWhy'),
    },
]


// WEBPACK FOOTER //
// ./src/router/explain.js